import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/subscriptionTier/importer/subscriptionTierImporterActions';

export default importerReducers(actions);
